var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "stitch": "",
      "help-content-id": "popup-producttype-".concat(_vm.current_entity_profile)
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('template', {
    slot: "content"
  }, [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_vm._v(_vm._s(_vm.$translate('informations')))]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('Field', {
    attrs: {
      "error-messages": _vm.form_errors.name,
      "label": _vm.$translate('name'),
      "name": "name",
      "autofocus": true,
      "required": ""
    },
    on: {
      "input": function input($event) {
        return _vm.computeProductCode($event);
      }
    },
    model: {
      value: _vm.producttype.label,
      callback: function callback($$v) {
        _vm.$set(_vm.producttype, "label", $$v);
      },
      expression: "producttype.label"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('Field', {
    attrs: {
      "value": _vm.producttype.code,
      "error-messages": _vm.form_errors.code,
      "label": _vm.$translate('code'),
      "required": ""
    },
    on: {
      "input": _vm.editProductCode
    }
  })], 1)], 1), _c('h5', {
    staticClass: "stitch-modal__title"
  }, [_vm._v(_vm._s(_vm.$translate('fields')))]), _vm._l(_vm.fields, function (field, idx) {
    return [_c('div', {
      key: idx,
      staticClass: "d-flex mb-3 secondary pa-3"
    }, [_c('div', {
      staticClass: "flex-grow-1"
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "4"
      }
    }, [_c('Field', {
      attrs: {
        "error-messages": _vm.form_errors.fields ? _vm.form_errors.fields[idx].label : null,
        "label": _vm.$translate('label'),
        "required": ""
      },
      on: {
        "input": function input($event) {
          return _vm.computeFieldCode(field);
        }
      },
      model: {
        value: field.label,
        callback: function callback($$v) {
          _vm.$set(field, "label", $$v);
        },
        expression: "field.label"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "4"
      }
    }, [_c('Field', {
      attrs: {
        "value": field.code,
        "error-messages": _vm.form_errors.fields ? _vm.form_errors.fields[idx].code : null,
        "disabled": !field["new"],
        "label": _vm.$translate('code'),
        "required": ""
      },
      on: {
        "input": function input($event) {
          return _vm.editFieldCode(field, $event);
        }
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "4"
      }
    }, [_c('Select', {
      attrs: {
        "error-messages": _vm.form_errors.fields ? _vm.form_errors.fields[idx] : null,
        "options": [{
          value: 'string',
          text: _vm.$translate('string')
        }, {
          value: 'integer',
          text: _vm.$translate('integer')
        }, {
          value: 'float',
          text: _vm.$translate('float')
        }, {
          value: 'boolean',
          text: _vm.$translate('boolean')
        }, {
          value: 'choices',
          text: _vm.$translate('choices')
        }],
        "label": _vm.$translate('type'),
        "required": ""
      },
      model: {
        value: field.type,
        callback: function callback($$v) {
          _vm.$set(field, "type", $$v);
        },
        expression: "field.type"
      }
    })], 1)], 1), _c('v-row', [_vm.unitNeeded(field) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "4"
      }
    }, [_c('Field', {
      attrs: {
        "error-messages": _vm.form_errors.fields ? _vm.form_errors.fields[idx].unit : null,
        "label": _vm.$translate('unit')
      },
      model: {
        value: field.unit,
        callback: function callback($$v) {
          _vm.$set(field, "unit", $$v);
        },
        expression: "field.unit"
      }
    })], 1) : _vm._e(), field.type == 'choices' ? _c('v-col', {
      staticClass: "pt-0",
      attrs: {
        "cols": "12",
        "sm": 12
      }
    }, [_c('v-combobox', {
      staticClass: "tag-input",
      attrs: {
        "multiple": "",
        "label": _vm.$translate('choices'),
        "append-icon": "",
        "chips": "",
        "deletable-chips": "",
        "search-input": field.choices_string,
        "outlined": "",
        "dense": ""
      },
      on: {
        "keyup": function keyup($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) return null;
          return _vm.updateTags(field);
        },
        "update:searchInput": function updateSearchInput($event) {
          return _vm.$set(field, "choices_string", $event);
        },
        "update:search-input": function updateSearchInput($event) {
          return _vm.$set(field, "choices_string", $event);
        },
        "paste": function paste($event) {
          return _vm.updateTags(field);
        }
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function fn() {
          return [_c('span', [_vm._v(_vm._s(_vm.$translate('choices')))]), _c('StitchHint', {
            attrs: {
              "hint": _vm.$translate('useTabKeyToValidateEachChoice')
            }
          })];
        },
        proxy: true
      }], null, true),
      model: {
        value: field.choices,
        callback: function callback($$v) {
          _vm.$set(field, "choices", $$v);
        },
        expression: "field.choices"
      }
    })], 1) : _vm._e(), _c('v-col', {
      staticClass: "pt-0",
      attrs: {
        "cols": "12",
        "sm": 12
      }
    }, [_c('v-checkbox', {
      attrs: {
        "label": _vm.$translate('enableFiltering')
      },
      model: {
        value: field.filter,
        callback: function callback($$v) {
          _vm.$set(field, "filter", $$v);
        },
        expression: "field.filter"
      }
    })], 1)], 1)], 1), _c('div', {
      staticClass: "d-flex justify-end align-start pt-5 ml-3"
    }, [_c('v-tooltip', {
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref) {
          var on = _ref.on,
            attrs = _ref.attrs;
          return [_c('v-icon', _vm._g(_vm._b({
            attrs: {
              "size": "20"
            },
            on: {
              "click": function click($event) {
                return _vm.deleteField(idx);
              }
            }
          }, 'v-icon', attrs, false), on), [_vm._v("mdi-delete")])];
        }
      }], null, true)
    }, [_c('span', [_vm._v(_vm._s(_vm.$translate('deleteField')))])])], 1)])];
  }), _c('div', {
    staticClass: "d-flex justify-end mt-0"
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.newFieldClicked.apply(null, arguments);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$translate('addField')))], 1)], 1), _vm.validFields.length ? [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_vm._v(_vm._s(_vm.$translate('productDescription')))]), _c('div', {
    staticClass: "d-flex mb-6 secondary pa-3 pt-5"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_c('v-row', [_c('v-col', [_c('span', [_vm._v(_vm._s(_vm.$translate('productDescriptionColon')))]), _vm._v("  "), _vm.descriptionFields.length ? _vm._l(_vm.descriptionFields, function (field, idx) {
    return _c('span', {
      key: JSON.stringify(field)
    }, [idx ? [_vm._v("-")] : _vm._e(), _c('b', [_vm._v(" " + _vm._s(field.label) + " ")])], 2);
  }) : _c('i', [_vm._v(_vm._s(_vm.$translate('addFieldsUsingButtonsBelow')))])], 2)], 1), _c('v-row', [_c('v-col', {
    staticClass: "d-flex flex-wrap",
    attrs: {
      "cols": "12"
    }
  }, _vm._l(_vm.validFields, function (field) {
    return _c('v-btn', {
      key: field.code + '-' + field.label,
      staticClass: "mr-4 mb-4",
      attrs: {
        "small": ""
      },
      on: {
        "click": function click($event) {
          return _vm.toggleFieldInDescription(field);
        }
      }
    }, [(_vm.producttype.description || []).indexOf(field.code) == -1 ? _c('v-icon', [_vm._v("mdi-plus")]) : _c('v-icon', [_vm._v("mdi-delete")]), _vm._v(" " + _vm._s(field.label) + " ")], 1);
  }), 1)], 1)], 1)])] : _vm._e()], 2), _c('template', {
    slot: "bottom"
  }, [_c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "text": _vm.$translate('cancel'),
      "ghost": ""
    },
    on: {
      "click": _vm.cancelEditClicked
    }
  }), _c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "text": _vm.save_text,
      "loading": _vm.producttype_saving
    },
    on: {
      "click": _vm.saveInformationClicked
    }
  })], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }